@if (lorenzFormGroup && lorenzFormControl) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper">

			<textarea [formControl]="lorenzFormControl"

					  class="control"
					  [ngClass]="{
						'readonly': lorenzFormControl.isBlocked(),
						'faulty': lorenzFormControl.isFaulty(),
						'missing-required': lorenzFormControl.isMissingRequiredValue(),
						'highlighted': lorenzFormControl.isHighlighted()
					  }"

					  [placeholder]="lorenzFormControl.getPlaceholder() | translate"

					  [attr.readonly]="lorenzFormControl.isBlocked() ? true : null"
					  [attr.rows]="rows"
					  
			></textarea>

			<lib-form-validity-dot [control]="lorenzFormControl" />

		</div>

		@if (showErrorMessages) {
			<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
		}

	</div>

}
